import { type PillarFormInputComponentConfig } from "shared/components/pillar-form/PillarFormInputComponentConfig";

export type PillarFormDynamicDateTimeType = "date" | "time" | "datetime-local";

/**
 * Pick the html input flavor for a date/time config element. `inputType`
 * narrows it to a date-only or time-only picker; anything else keeps both.
 */
export const resolveDynamicDateTimeType = (
  element: PillarFormInputComponentConfig,
): PillarFormDynamicDateTimeType => {
  const inputType = String(element.inputType || "").toLowerCase();

  if (inputType === "date") {
    return "date";
  }

  if (inputType === "time") {
    return "time";
  }

  return "datetime-local";
};
